















import { Component, Prop, Mixins, Emit, Ref } from 'vue-property-decorator';
import { SaveIcon } from '@/components/icons/SaveIcon';
import BaseMixin from '@/mixins/BaseMixin';

@Component({
    components: {
        SaveIcon,
    },
})
export default class AddCart extends Mixins(BaseMixin) {
    @Ref('cartInput')
    private readonly cartInput!: HTMLInputElement;

    private cartName: string = '';

    protected mounted(): void {
        this.cartInput.focus();
    }

    private get isValid(): boolean {
        return this.cartName !== '';
    }

    @Emit('add')
    private add(): string {
        return this.cartName;
    }
}
